import React from 'react';
import { UseFormRegister } from 'react-hook-form';
import { FormattedMessage, useIntl } from 'react-intl';
import { SOURCE_CHANGE_OPTIONS } from '../utils/const';

interface SourceSelectorProps {
  register?: UseFormRegister<any>;
  source?: string;
  onSourceChange?: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  sourceError?: string;
  otherSource?: string;
  onOtherSourceChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  otherSourceError?: string;
  errorStyles?: string;
}

export const SourceSelector: React.FC<SourceSelectorProps> = ({
  register,
  sourceError,
  source,
  onSourceChange,
  otherSource,
  onOtherSourceChange,
  otherSourceError,
  errorStyles,
}) => {
  const intl = useIntl();
  const showOtherInput = source === SOURCE_CHANGE_OPTIONS.OTHER_REQUEST;

  return (
    <>
      <fieldset className="t-form-field mt2">
        <FormattedMessage tagName="label" id="select-source" />

        {register ? (
          <select defaultValue="" {...register('source', { required: true })}>
            <option value="" disabled hidden>
              {intl.formatMessage({ id: 'select-source' })}
            </option>
            {Object.values(SOURCE_CHANGE_OPTIONS).map((option) => (
              <option key={option} value={option}>
                {intl.formatMessage({ id: option })}
              </option>
            ))}
          </select>
        ) : (
          <select value={source} onChange={onSourceChange}>
            <option value="" disabled hidden>
              {intl.formatMessage({ id: 'select-source' })}
            </option>
            {Object.values(SOURCE_CHANGE_OPTIONS).map((option) => (
              <option key={option} value={option}>
                {intl.formatMessage({ id: option })}
              </option>
            ))}
          </select>
        )}
        {sourceError && <span>{sourceError}</span>}
      </fieldset>

      {showOtherInput && (
        <fieldset className="t-form-field mt2">
          <FormattedMessage tagName="label" id="other-source" />
          {register ? (
            <input
              placeholder={intl.formatMessage({ id: 'other-source-input' })}
              {...register('otherSource')}
            />
          ) : (
            <input
              placeholder={intl.formatMessage({ id: 'other-source-input' })}
              value={otherSource || ''}
              onChange={onOtherSourceChange}
            />
          )}
          {otherSourceError && <span>{otherSourceError}</span>}
        </fieldset>
      )}
    </>
  );
};
